/** Статус окна/пульта в очереди re:turn */
export enum ReturnPultStatusType {
	/** Пульт не активирован (окно закрыто) */
	Offline,
	/** Окно свободно, готово вызывать следующего посетителя */
	Waiting,
	/** Посетитель вызван, идет ожидание/подтверждение */
	Calling,
	/** Идет обслуживание посетителя */
	Working,
	/** Окно находится на перерыве */
	OnPause,
	/** Посетитель выбран, ожидается подтверждение вызова */
	Selected
}

/** Талон, с которым сейчас работает оператор */
export type ReturnTicketModelType = {
	/** Системный идентификатор талона */
	id: string;
	/** Номер талона */
	number: string;
	/** Наименование услуги */
	operation: string;
	/** ФИО заявителя */
	customerName?: string;
	/** Время приглашения */
	inviteTime?: string;
	/** Время начала обслуживания */
	startTime?: string;
	/** Дополнительные признаки/комментарии талона */
	priorityFlags?: string[];
};

/** Текущее состояние re:turn, которое отдает backend */
export type ReturnStateType = {
	/** Текущий статус пульта/окна */
	pultStatus: ReturnPultStatusType;
	/** Текущий талон (может отсутствовать, если никто не вызван) */
	ticket?: ReturnTicketModelType;
	/** Текстовое сообщение backend (ошибка/инфо) */
	message?: string;
	/**
	 * Сообщение о причине, по которой смена не была закрыта.
	 * Непустое значение означает, что CloseWorkday/Finish не смог закрыть окно;
	 * pultStatus при этом содержит актуальное состояние пульта.
	 */
	closingError?: string;
};

/** Сводные счетчики очереди */
export type ReturnQueueCountType = {
	/** Количество талонов в основной очереди */
	queueCount: number;
	/** Количество отложенных талонов */
	defferedCount: number;
	/** Количество талонов, перенаправленных в это окно */
	transferedCount: number;
};

/** Элемент списка очереди для модалки "Вызов по талону" */
export type ReturnQueueItemType = {
	/** Идентификатор талона */
	id: string;
	/** Наименование услуги */
	name: string;
	/** Время создания талона */
	timeCreated: string;
	/** Номер талона */
	ticketNumber: string;
};
